import { useTranslation } from "react-i18next";
import { SettingsIcon } from "@/shared/icons";
import { Button } from "@/shared/ui";

type Props = {
  onClick: () => void;
};

export default function AccountSettingsTrigger({ onClick }: Props) {
  const { t } = useTranslation("account");

  return (
    <Button
      type="button"
      variant="soft"
      color="gray"
      className="w-full mt-2 h-11"
      onClick={onClick}
    >
      <SettingsIcon size={16} className="mr-2.5" />
      {t("account.accountSettings")}
    </Button>
  );
}
